import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import createSyarahV2Fetcher from "@/common/fetchSyarahv2";

//TODO: add correct sources

var mapScenarioTextToScenario = function mapScenarioTextToScenario(scenario_text) {
  switch (scenario_text) {
    case "login":
      return 2;
    case "signup":
      return 4;
    case "update_phone":
      return 3;
  }
};
export var api__verifyOtp = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var source, phone_number, otp, scenario_text, _ref$full_name, full_name, _ref$city_id, city_id, order_id, is_finance, params, responseData;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          source = _ref.source, phone_number = _ref.phone_number, otp = _ref.otp, scenario_text = _ref.scenario_text, _ref$full_name = _ref.full_name, full_name = _ref$full_name === void 0 ? '' : _ref$full_name, _ref$city_id = _ref.city_id, city_id = _ref$city_id === void 0 ? '' : _ref$city_id, order_id = _ref.order_id, is_finance = _ref.is_finance;
          params = {
            phone_number: phone_number,
            otp: otp,
            scenario: mapScenarioTextToScenario(scenario_text)
          };
          full_name && (params["full_name"] = full_name);
          city_id && (params["city_id"] = city_id);
          order_id && (params["order_id"] = order_id);
          is_finance && (params["is_finance"] = is_finance);
          _context.next = 8;
          return createSyarahV2Fetcher({
            throwValidationException: true
          }).post("/auth/otp-verify?source=".concat(source), params);
        case 8:
          responseData = _context.sent;
          return _context.abrupt("return", responseData.data.data);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function api__verifyOtp(_x) {
    return _ref2.apply(this, arguments);
  };
}();